// extracted by mini-css-extract-plugin
module.exports = {"welcomeContainer":"WelcomePage_welcomeContainer__sBJ7G"};